import { TextField, InputAdornment, styled, useTheme } from '@mui/material';
import { type InputProps as StandardInputProps } from '@mui/material/Input/Input';
import SearchIcon from '@mui/icons-material/Search';
import { useTranslation } from 'react-i18next';
import { type TextFieldProps } from '@mui/material/TextField/TextField';

export const TextFieldWrapper = styled(TextField)(({ theme }) => ({
  [`& fieldset`]: {
    borderColor: theme.palette.input.borderColor
  }
}));

type SearchFieldProps = {
  onSearch: StandardInputProps['onChange'];
} & TextFieldProps;

export const SearchField = ({ onSearch, ...rest }: SearchFieldProps) => {
  const { t } = useTranslation('common');
  const theme = useTheme();

  return (
    <TextFieldWrapper
      fullWidth
      placeholder={`${t('search')}`}
      variant="outlined"
      onChange={onSearch}
      InputProps={{
        sx: { background: theme.palette.background.paper },
        endAdornment: (
          <InputAdornment position="start">
            <SearchIcon color="primary" />
          </InputAdornment>
        )
      }}
      {...rest}
    />
  );
};
